import { h, Component } from 'preact';
import CSSModules from 'react-css-modules';
import styles from '../../css/app.css';
import safari from 'is-safari';

import appEvents from '../../utils-and-data/events.js';
import DefaultImage from '../../img/default-user-media.jpg';

class CameraControl extends Component {
  constructor(props) {
    super(props);
    this.slices = {};
    window.userMediaImg = DefaultImage;
  }

  componentDidMount() {
    this.mediaLoadPromise = new Promise((res, rej) => {
      this.mediaLoadResolve = res;
    });

    this.ctx = this.canvas.getContext('2d');
    appEvents.on('getUserMedia', this.onGetUserMedia);
  }

  onGetUserMedia = () => {

    // Start camera, if it's not going already...
    if (!this.cameraStarted) {
      // console.log('RESTART CAMERA:', this.video.srcObject);
      this.start();
    }

    setTimeout(() => {
      this.mediaLoadPromise.then(() => {
        let snapshot = this.snapshot();
        window.userMediaImg = snapshot ? snapshot : window.userMediaImg;
        // if (snapshot) console.log('CAMERA SUCCESSFUL. new image:', snapshot);
        appEvents.emit('imageLoaded');

        // Stop the camera capture..
        this.stop();
      });
    }, 1000); 
    //  ^ allow some time for the camera to auto-light-balance...
  }

  stop() {
    console.log('stop camera!!!!!', this.video.srcObject);
    this.cameraStarted = false;
    if (this.video.srcObject) {
      this.video.srcObject.getTracks().map(t => t.stop());
    }
  }

  start() {
    
    console.log('camera starting!!!');
    if (this.cameraStarted) return;

    // @TODO: ATM the camera selected is the
    // one facing the users face...
    if (!navigator.mediaDevices) {
      this.useDefaultImage();
    } else {

      // @TODO: the below "ideal" prop currently
      // gives "OverconstrainedError" in SAFARI ...
      // width: { ideal: 450 },
      let width = safari
        ? 640
        // ^ Any other width setting other than 640, seems to end up in
        // "Invalid constraint" inside Safari. Stupid, bloody iOS ...
        : { min: 640, ideal: 1080, max: 1080 };
      this.cameraStarted = true;
      navigator.mediaDevices.getUserMedia({
        video: {
          width: width,
          facingMode: this.props.facing,
          aspectRatio: 1.33,
          frameRate: { max: 30 }
        }})
        .then(stream => {
          this.video.srcObject = stream;
          this.video.style.opacity = 1;
          this.setState({ usingDefaultImg: false });
          this.video.addEventListener('canplay', () => {
            this.video.play();
            this.mediaLoadResolve();
          });
        })
        .catch(e => {
          this.useDefaultImage();
          console.error(e);
        });
    }
  }

  snapshot = () => {
    this.video.style.opacity = 0;
    if (this.state.usingDefaultImg) {
      return false;
    } else {

      // Draw a copy of the current frame from the video on the canvas.
      // (Crop from the center to 1:1)
      let minDim = Math.min(this.video.videoWidth, this.video.videoHeight);
      this.canvas.width = this.canvas.height = minDim;
      let startX = (this.video.videoWidth - minDim) * 0.5;
      let startY = (this.video.videoHeight - minDim) * 0.5;
      // image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight
      this.ctx.drawImage(
        this.video,
        startX, startY,
        minDim, minDim,
        0, 0,
        minDim, minDim
      );

      return this.canvas.toDataURL('image/png');
    }
  }

  useDefaultImage = () => {
    this.cameraStarted = false;
    this.mediaLoadResolve();
    // Don't load the default image unless it's needed...
    this.image.src = DefaultImage;
    this.setState({ usingDefaultImg: true });
  }

  storeRef(type, el) {
    // console.log('store a ref:', el);
    if (el !== null) this[type] = el;
  }

  render() {
    let imgOpacity = 0;
    if (this.state.usingDefaultImg 
      && this.props.currentSection === null) imgOpacity = 1;

    return (
      <div styleName='temp-canvas-container'
        ref={c => this.storeRef('container', c)}>

        <video muted playsinline autoplay
          ref={v => this.storeRef('video', v)} />
        <canvas ref={c => this.storeRef('canvas', c)} />
        <img ref={c => this.storeRef('image', c)}
          style={{ opacity: imgOpacity }} />
      </div>
    );
  }
}

export default CSSModules(CameraControl, styles);



// WEBPACK FOOTER //
// ./app/frontend/components/sensor-axs/camera-control.jsx